import styles from "./Input.module.css";
import React, { useEffect, useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function InputV2(props) {
  const [showPassword, setShowPassword] = useState(false);

  const type = props.type === "password" && showPassword ? "text" : props.type || "text";

  const togglePasswordVisibility = () => {
    if (props.type === "password") {
      setShowPassword(!showPassword);
    }
  };

  return (
    <div>
      <div className="relative inline-block w-full border border-[#E1DFE3] rounded-[5px]">
        <input
          type={type}
          id={props.id}
          name={props.name}
          value={props.value || ""}
          className={`${styles.input} ${props.disabled ? styles.disabled : ""} ${
            props.value ? "" : styles.value
          } w-full rounded-[5px] p-[1px_8px]`}
          style={props.style}
          disabled={props.disabled || false}
          placeholder={props.placeholder}
          onFocus={props.onFocus}
          onBlur={props.onBlur}
          maxLength={props.maxLength}
          onChange={(e) => {
            if (props.onChangeEvt) {
              props.onChangeEvt(e.target.value);
            }
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter" && props.onEnter) {
              props.onEnter();
            }
          }}
        />
        <div
          className="absolute cursor-pointer"
          style={{
            transform: "translateY(-50%)",
            pointerEvents: "auto",
            right: "11px",
            top: "50%",
            color: "#747081",
          }}
          onClick={togglePasswordVisibility}
        >
          {props.type === "password" &&
            (showPassword ? <FaEyeSlash /> : <FaEye />)}
        </div>
      </div>
    </div>
  );
}

export default InputV2;

